/**
 * Configuration
 */
export class Configuration {
    /**
     * Sets namespace
     * @param value namespace value
     */
    static setNamespace(value) {
        this.namespace = value;
    }
    /**
     * Gets namespace
     */
    static getNamespace() {
        return this.namespace;
    }
    /**
     * Sets debug enabled
     * @param value
     */
    static setDebugEnabled(value) {
        sessionStorage.setItem(`${this.namespace}.traceEnabled`, JSON.stringify(value));
    }
    /**
     * Checks if debug is enabled
     */
    static isDebugEnabled() {
        const value = sessionStorage.getItem(`${this.namespace}.debugEnabled`);
        return value ? JSON.parse(value) : false;
    }
}
Configuration.namespace = 'duice';
//# sourceMappingURL=Configuration.js.map